import styled from "styled-components";
import { AllIconName, Icon } from "../Icon";
import { Paragraph, Subtitle } from "../Text";
import { ReactElement } from "react";
import React from "react";

export enum EmptyPlaceholderTestIds {
  Container = "empty-placeholder",
  Icon = "empty-placeholder-icon",
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding-block: 32px 52px;
  gap: 8px;

  p {
    margin: 0;
  }
`;

type EmptyPlaceholderProps = {
  iconName: AllIconName;
  title: string;
  description?: string | ReactElement;
  className?: string;
};

export const EmptyPlaceholder = ({
  iconName = "add",
  title,
  description,
  className = "",
}: EmptyPlaceholderProps) => (
  <Container
    data-testid={EmptyPlaceholderTestIds.Container}
    className={className}
  >
    <Icon
      data-testid={EmptyPlaceholderTestIds.Icon}
      iconName={iconName}
      plain
      iconSize="extraLarge"
    />
    <Subtitle type="1" typeface="montserrat">
      {title}
    </Subtitle>
    {/* default description styles */}
    {typeof description === "string" && (
      <Paragraph
        type="3"
        color="primary-400"
        typeface="montserrat"
        textAlign="center"
      >
        {description}
      </Paragraph>
    )}
    {/* For custom CTA and text */}
    {React.isValidElement(description) && description}
  </Container>
);
